import React, { forwardRef, useId } from 'react';
import cx from 'classnames';
import { ArcAnimationMask } from '../../../internal/ArcAnimationMask/index.js';
import styles from './index.module.scss.js';

const Button = forwardRef(
  ({
    className,
    style,
    type = "button",
    text,
    themeKind = "blue",
    size,
    icon,
    iconLeft,
    isActive = false,
    noBorder,
    hasOutlineHover = false,
    ...props
  }, forwardedRef) => {
    const maskId = useId();
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        ...props,
        ref: forwardedRef,
        className: cx(styles.box, className, {
          [styles.active]: isActive,
          [styles[themeKind]]: !!themeKind,
          [styles["outline-hover"]]: hasOutlineHover,
          [styles[size]]: !!size,
          [styles["no-border"]]: noBorder
        }),
        style: {
          ...style,
          "--mask-url": `url(#${maskId})`
        },
        type
      },
      iconLeft && icon,
      text,
      !iconLeft && icon,
      hasOutlineHover && /* @__PURE__ */ React.createElement(ArcAnimationMask, { maskId })
    );
  }
);
Button.displayName = "Button";

export { Button };
//# sourceMappingURL=index.js.map
